import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100vh;
  width: 100vw;

  display: grid;
  grid-template-columns: auto max-content;
`;
